export default __webpack_public_path__ + "static/media/TSchedule3.1d433a4b.png";